import closures_blog from "./closures_blog.png"
import RN_Optimization from "./RN_Optimization.png"
import RN_ARCH from "./React-Native-Architecture-.png"

import SET_MAP_BLOG from "./SET_MAP_BLOG.png"
import BROWSER_WORKS from "./browserlogos2021 (1).png"


export const BLOGS_IMAGES = {
  closures_blog,
  RN_Optimization,
  SET_MAP_BLOG,
  BROWSER_WORKS,
  RN_ARCH
}
